<template>
    <v-card>
        <v-card-text class="pb-1">
            <v-row>
                <v-col
                    cols="4">
                    <v-text-field
                        outlined
                        hide-details
                        height="40px"
                        append-icon="search"
                        v-model="pagination.search"
                        :placeholder="$t('placeholder.filterByCustonerName')"/>
                </v-col>
                <v-col cols="8">
                    <v-btn
                        class="float-right"
                        color="primary"
                        @click="openCreateCustomerGroupPanel">
                        {{ $t('button.createCustomer') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <customer-group-table
                :search="pagination.search"
                :items="customerGroups"
                :options="pagination"
                @edit="openEditCustomerGroupPanel"/>
        </v-card-text>

        <right-panel
            ref="createCustomerGroupPanel"
            :title="$t('customerGroupList.details.createHeader')">
            <template v-slot:content="{ context }">
                <customer-group-details-view
                    create-mode
                    :customerGroup="context"/>
            </template>

            <template v-slot:bottom>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary">
                    {{ $t('button.create') }}
                </v-btn>
            </template>
        </right-panel>

        <right-panel
            ref="editCustomerGroupPanel"
            :title="$t('customerGroupList.details.editHeader')">
            <template v-slot:headerAction>
                <v-btn
                    outlined
                    color="primary">
                    {{ $t('button.viewActivityHistory') }}
                </v-btn>
            </template>
            <template v-slot:content="{ context }">
                <customer-group-details-view
                    :customerGroup="context"/>
            </template>
            <template v-slot:bottom>
                <v-menu
                    top
                    offset-y
                    nudge-top="12px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            outlined
                            width="120px"
                            color="primary"
                            v-on="on"
                            v-bind="attrs">
                            <icon
                                class="mr-1"
                                value="hero_Trash"
                                size="18px"/>
                            {{ $t('button.delete') }}
                        </v-btn>
                    </template>
                    <v-card elevation="0">
                        <v-card-title class="error--text">
                            <icon
                                value="error_outline"
                                class="mr-2 error--text"/>
                            {{ $t('customerGroupList.dialog.delete.header') }}
                        </v-card-title>
                        <v-card-text v-html="$t('customerGroupList.dialog.delete.content')">
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn
                                outlined
                                color="grey">
                                {{ $t('customerGroupList.dialog.delete.cancel') }}
                            </v-btn>
                            <v-btn
                                color="error">
                                {{ $t('customerGroupList.dialog.delete.confirm') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary">
                    {{ $t('button.save') }}
                </v-btn>
            </template>
        </right-panel>
    </v-card>
</template>

<script>
import RightPanel from '@/components/panels/RightPanel'
import CustomerGroupTable from '@/components/tables/CustomerGroupTable'
import CustomerGroupDetailsView from '@/views/CustomerGroupDetailsView'

export default {
    name: 'CustomerGroupListView',

    components: {
        RightPanel,
        CustomerGroupDetailsView,
        CustomerGroupTable
    },

    props: {
        customerGroups: {
            type: Array,
            default: () => []
        },

        pagination: {
            type: Object,
            default: () => ({})
        }
    },

    methods: {
        openEditCustomerGroupPanel (customerGroupItem) {
            this.$refs.editCustomerGroupPanel.open(customerGroupItem)
        },

        openCreateCustomerGroupPanel () {
            this.$refs.createCustomerGroupPanel.open({
                addressInfo: {},
                deliveryAddress: {},
                contact: {}
            })
        }
    }
}
</script>

<style lang="scss" scoped></style>
